import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { QuickFlowModal } from "./quickflow-modal";
import { gql, useMutation } from "@apollo/client";
const UUID_KEY = "uuid";
const UUID_FROM_LOCAL_STORAGE = localStorage.getItem(UUID_KEY);

const SAVE_OPEN_VIEWS = gql`
  mutation SaveOpenDocView($doc_id: Int!, $client_id: String!) {
    saveOpenDocView(doc_id: $doc_id, client_id: $client_id)
  }
`;

export const QuickFlowOpen = (props: any) => {
  const params = useParams();
  const document_id = +params.id!;
  const navigate = useNavigate();
  const [uuid, setUuid] = useState(UUID_FROM_LOCAL_STORAGE ?? crypto.randomUUID());
  const [saveOpenViews] = useMutation(SAVE_OPEN_VIEWS);

  useEffect(() => {
    if(!UUID_FROM_LOCAL_STORAGE) {
      localStorage.setItem(UUID_KEY, uuid);
    }
  }, [uuid]);

  useEffect(() => {
    console.log("********************************** UUID", uuid);
    saveOpenViews({ variables: { doc_id: document_id, client_id: uuid } });
  }, [uuid]);

  const allowedHosts = ["product.mindstrength.co", "demo.mindstrength.co", "localhost", "rollease.mindstrength.co", "orohosp.mindstrength.co", "window.mindstrength.co"];

  if(allowedHosts.indexOf(window.location.hostname) === -1) {
    return (
      <Navigate to="/home" />
    )
  }

  return (
    <div className="flex flex-1" style={{ background: "#cfdaf5" }}>
      <div className="max-w-xl mx-auto flex flex-1 w-full bg-white">
        <QuickFlowModal hideClose={true} hideShare={true} closePreview={() => navigate("/login")} refDocId={document_id} />
      </div>
    </div>
  )
};
